interface AssetAllocationTotalProps {
  totalAllocation: number;
}

const AssetAllocationTotal = ({ totalAllocation }: AssetAllocationTotalProps) => {
  return (
    <div className="bg-navy/5 p-4 rounded-lg">
      <h3 className="font-semibold text-navy text-center">
        Total Allocation: {' '}
        <span className={totalAllocation !== 100 ? "text-destructive" : ""}>
          {totalAllocation}%
        </span>
      </h3>
    </div>
  );
};

export default AssetAllocationTotal;
